import React from "react";
import { Typography } from "antd";
import "./Scope.css";
import ProgressBar from "../../../ProgressBar/ProgressBar";
import ProgressCircle from "../../../ProgressCircle/ProgressCircle";

const { Text } = Typography;

const Scope = ({ id, title, subtitle, percent, isActive }) => {
  return (
    <div className="scope-container">
      <div className="scope-content">
        <ProgressCircle 
          percentCircle={percent} 
          width={'auto'} 
          isActive={isActive} 
          
        />
        <div className="text-container">
          <Text className="title-scope">{title}</Text>
          <Text className="subtitle-scope">{subtitle}</Text>
          <div className="progress-bar-container">
            <ProgressBar percent={percent} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Scope;